var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css, } from 'styled-components';
import { ScreenReaderOnly } from '../../ScreenReaderOnly';
import { TextBody, headerBaseStyles, TextHeading, } from '../../Typography';
const visibleCaptionStyles = css `
  ${({ theme: { space } }) => `
    padding-bottom: ${space.md};
    text-align: left;
  `}
  ${headerBaseStyles}
`;
const captionStyles = css `
  ${({ $isVisible, theme: { screenReader }, }) => $isVisible ? visibleCaptionStyles : screenReader.srOnlyInline}
`;
const StyledTextBody = styled(TextBody) `
  ${captionStyles}
`;
const StyledTextHeading = styled(TextHeading) `
  ${captionStyles}
`;
const CaptionRefForwarding = (_a, ref) => {
    var { text, isVisible, size = 'xs', paginationInformation } = _a, discriminatedProps = __rest(_a, ["text", "isVisible", "size", "paginationInformation"]);
    const sharedProps = {
        fontWeight: 'bold',
        weight: 'bold',
        fontStyle: 'inherit',
        outlineOnFocus: false,
        size,
        $isVisible: isVisible,
        tabIndex: -1,
        'data-testid': `mui-${discriminatedProps.variant}-caption`,
        children: [
            text,
            paginationInformation && (React.createElement(ScreenReaderOnly, { "data-testid": `mui-${discriminatedProps.variant}-caption-pagination-info`, key: `mui-${discriminatedProps.variant}-caption-pagination-info` },
                ' ',
                paginationInformation)),
        ],
    };
    return discriminatedProps.variant === 'table' ? (React.createElement(StyledTextBody, Object.assign({ tag: "caption" }, sharedProps, { ref: ref }))) : (React.createElement(StyledTextHeading, Object.assign({ tag: discriminatedProps.headingLevel || 'h2' }, sharedProps, { id: discriminatedProps.captionId, ref: ref })));
};
export const Caption = React.forwardRef(CaptionRefForwarding);
//# sourceMappingURL=Caption.js.map